import React from "react";
import { GridColDef } from "@mui/x-data-grid";

export const PRIORITY_FILTER_OPTIONS = ["Urgent", "High", "Medium", "Low"];

/** Same status options as Ticket Status Summary (LatestStatusReport) */
export const WORKFLOW_STATUS_OPTIONS: { label: string; value: string }[] = [
  { label: "Active", value: "active" },
  { label: "Closed", value: "closed" },
  { label: "Reopen", value: "reopen" },
  { label: "In Progress", value: "wip" },
];

export const WORKFLOW_STATUS_VALUES = WORKFLOW_STATUS_OPTIONS.map(
  (option) => option.value,
);

export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

export const extractRows = (reportData: unknown): any[] => {
  const payload = reportData as Record<string, unknown>;
  if (Array.isArray(payload?.results)) return payload.results as any[];
  if (Array.isArray(payload?.data)) return payload.data as any[];
  if (Array.isArray(reportData)) return reportData as any[];
  return [];
};

export const buildColumnsFromRow = (row: Record<string, unknown>): GridColDef[] => {
  const keys = Object.keys(row).filter((key) => key !== "id" && key !== "sno");
  return [
    {
      field: "sno",
      headerName: "S.No.",
      width: 80,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
    ...keys.map((key) => ({
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 120,
      align: "center" as const,
      headerAlign: "center" as const,
    })),
  ];
};

export const processRowValues = (row: Record<string, unknown>) => {
  const processed: Record<string, unknown> = {};
  Object.entries(row).forEach(([key, value]) => {
    processed[key] =
      value === null || value === undefined || value === "" ? "-" : value;
  });
  return processed;
};

export const serializeParams = (queryParams: Record<string, string | number>) =>
  JSON.stringify(queryParams, Object.keys(queryParams).sort());

export const toggleMultiSelect = (
  value: string,
  setSelected: React.Dispatch<React.SetStateAction<string[]>>,
  allOptions: string[],
) => {
  if (value === "all") {
    setSelected((prev) =>
      prev.length === allOptions.length ? [] : [...allOptions],
    );
    return;
  }
  setSelected((prev) =>
    prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
  );
};

export const toApiPriority = (priority: string) => priority.toLowerCase();

export const buildSingleOrMultiParam = (
  selected: string[],
  allOptions: string[],
  singleKey: string,
  multiKey: string,
  transform: (value: string) => string = (value) => value,
) => {
  const effective =
    selected.length === 0 || selected.length === allOptions.length
      ? allOptions
      : selected;

  if (!effective.length) return null;

  const values = effective.map(transform);
  if (values.length === 1) {
    return { [singleKey]: values[0] };
  }
  return { [multiKey]: values.join(",") };
};
